import { Navigate, useParams } from 'react-router-dom';
import ProductPageLayout from '../components/ProductPageLayout';
import { PRODUCT_PAGES } from '../config/productPages';

export default function ProductDetail() {
  const { productId } = useParams();
  const page = PRODUCT_PAGES[productId];

  if (!page) {
    return <Navigate to="/products" replace />;
  }

  return <ProductPageLayout page={page} />;
}
